import { HubConnection } from "@microsoft/signalr";
export const SET_FLEET_MANAGER_HUB = "SET_FLEET_MANAGER_HUB";

export interface IFleetManagerHubPayload {
  hub?: HubConnection;
}

export const createSetFleetManagerHubAction = (
  payload: IFleetManagerHubPayload
) => {
  return { type: SET_FLEET_MANAGER_HUB, payload: payload };
};
